var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcElection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10614",
    "data-name": "Group 10614",
    transform: "translate(-350 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 30,
    height: 30,
    transform: "translate(350 244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ballot",
    d: "M17,24H7a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,7,0H17a5.006,5.006,0,0,1,5,5V19A5.006,5.006,0,0,1,17,24ZM7,2A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3ZM18,6a1,1,0,0,0-1-1H13a1,1,0,0,0,0,2h4A1,1,0,0,0,18,6Zm0,6a1,1,0,0,0-1-1H13a1,1,0,0,0,0,2h4A1,1,0,0,0,18,12Zm0,6a1,1,0,0,0-1-1H13a1,1,0,0,0,0,2h4A1,1,0,0,0,18,18ZM10,7V5A1,1,0,0,0,9,4H7A1,1,0,0,0,6,5V7A1,1,0,0,0,7,8H9A1,1,0,0,0,10,7Zm0,6V11a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9A1,1,0,0,0,10,13Zm0,6V17a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9A1,1,0,0,0,10,19Z",
    transform: "translate(353 247)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcElection);
export default __webpack_public_path__ + "static/media/ic_election.e070cd41bc71bf7798a319123d3743d3.svg";
export { ForwardRef as ReactComponent };